import { render, staticRenderFns } from "./CommonInput.vue?vue&type=template&id=2ae6208c&scoped=true&"
import script from "./CommonInput.vue?vue&type=script&lang=js&"
export * from "./CommonInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae6208c",
  null
  
)

export default component.exports